import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faMapMarkerAlt, faPhone, faEnvelope, faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import INFO from "../../data/user";
import "./styles/footer.css";

const Footer = () => {
	const currentYear = new Date().getFullYear();
	const navigate = useNavigate();

	const handleClick = (path) => {
		navigate(path);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<div className="footer">
			<div className="footer-content">
				<div className="footer-column footer-branding">
					<div className="footer-logo">
						<Link to="/">
							<img
								src={INFO.main.logo}
								alt="Pasmo Logo"
								className="footer-logo-image"
							/>
						</Link>
					</div>
					<p className="footer-tagline">Your neighborhood beauty destination in Falls Church, VA</p>
					<div className="footer-social">
						<a 
							href={INFO.socials.instagram} 
							target="_blank" 
							rel="noreferrer"
							aria-label="Follow us on Instagram"
							className="social-link"
						>
							<FontAwesomeIcon icon={faInstagram} />
						</a>
						<a 
							href={INFO.socials.vagaro} 
							target="_blank" 
							rel="noreferrer"
							aria-label="Book an appointment"
							className="social-link booking"
						>
							<FontAwesomeIcon icon={faCalendarDays} />
						</a>
					</div>
				</div>
				
				<div className="footer-column footer-nav">
					<h3 className="footer-heading">Quick Links</h3>
					<div className="footer-links">
						<button onClick={() => handleClick('/')} className="footer-link">Home</button>
						<button onClick={() => handleClick('/about')} className="footer-link">About</button>
						<button onClick={() => handleClick('/services')} className="footer-link">Services</button>
						<button onClick={() => handleClick('/articles')} className="footer-link">Blog</button>
						<button onClick={() => handleClick('/contact')} className="footer-link">Contact</button>
					</div>
				</div>
				
				<div className="footer-column footer-contact">
					<h3 className="footer-heading">Contact Us</h3>
					<div className="footer-contact-items">
						<div className="contact-item">
							<FontAwesomeIcon icon={faMapMarkerAlt} className="contact-icon" />
							<p>7121 Leesburg Pike Suite, Falls Church, VA 22043</p>
						</div>
						{/* <div className="contact-item">
							<FontAwesomeIcon icon={faPhone} className="contact-icon" />
							<p>+1 (703) 555-1234</p>
						</div> */}
						<div className="contact-item">
							<FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
							<p>{INFO.main.email}</p>
						</div>
					</div>
				</div>
			</div>
			
			<div className="footer-bottom">
				<p>&copy; {currentYear} Pasmo The Beauty Lab. All rights reserved.</p>
				<p>Designed with 💕 in Virginia</p>
			</div>
		</div>
	);
};

export default Footer;
